<template>
  <div id="my-picks">
    <h2 class="shrink text-center logo-small mb-2">
      <span class="primary--text">My Entries</span>
    </h2>
    <v-sheet class="bg2 pa-4">
      <template v-for="(pick, i) in picks">
      <div v-if="pick.uid == userID" :key="i">
        <div class="d-flex justify-space-between">
          <span>{{pick.name}} - ({{countTeamsLeft(pick.teams)}}/{{pick.teams.length}})</span>
          <span>{{pick.total}}</span>
        </div>
        <v-sheet class="pa-1 border-grey bg3">
          <v-chip label class="pl-1 mr-1 mb-1" v-for="team in currentTeams(pick.teams)" :key="team[1].name">
            <v-avatar tile class="mr-2 grey">{{team[1].seed}}</v-avatar>
            {{team[1].name}} - {{team[1].total}}
            <v-icon v-if="team[1].elim" right small class="red--text">mdi-close</v-icon>
            <v-icon v-else right class="green--text">mdi-check</v-icon>
          </v-chip>
        </v-sheet>
        <div class="d-flex justify-end">
          <!-- <v-btn x-small color="green" class="mr-2" :to="{name: 'MakeEntry', params: {uid: pick.uid, timestamp: pick.timestamp}}">
            <v-icon x-small>mdi-pencil</v-icon>Edit
          </v-btn> -->
          <v-btn v-if="status === 0" x-small color="red" @click="deletePick(pick.uid, pick.timestamp)">
            <v-icon x-small>mdi-delete</v-icon>Delete
          </v-btn>
        </div>
        <v-divider class="my-2"></v-divider>
      </div>
      </template> 
    </v-sheet>
  </div>
</template>

<script>
import {mxPicks} from '../mixins/mxPicks'
import { fa } from '@/db'

export default {
  name: 'picks',
  mixins: [mxPicks],
  data() {
    return {
      
    }
  },
  computed: {
    picks() {
      return this.$store.getters.picks
    },
    status() {
      return this.$store.getters.status
    },
    userID() {
      return fa.currentUser.uid
    }
  },
  methods: {
    countTeamsLeft(teams) {
      let l = 0
      teams.forEach(t => {
        let r = Number(t.substring(1,2)) - 1
        l += (!this.teams[r][t].elim) ? 1 : 0
      })
      return l
    },
    currentTeams(teams) {
      return teams.map(t => {
        let r = Number(t.substring(1,2)) - 1
        return [t,this.teams[r][t]]
      })
    },
    deletePick(uid, ts) {
      this.$store.dispatch('deletePick', {uid, ts})
    }
  },
  mounted() {
    console.log('mounted');
  }
}
</script>

<style>

</style>
